import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from 'app/src/queries/withCount';

const ERRORS = `errors { path, message }`;

const BANK_ACCOUNT_CORE_FIELDS = gql`
  fragment BankAccountCoreFields on BankAccount {
    id
    ownerType
    ownerId
    accountName
    bankName
    routingNumberMasked
    accountNumberMasked
    routingNumber
    accountNumber
    type
    hiddenAt
  }
`;

export const BANK_ACCOUNT_FIELDS = gql`
  ${BANK_ACCOUNT_CORE_FIELDS}
  fragment BankAccountFields on BankAccount {
    ...BankAccountCoreFields
  }
`;

export const BANK_ACCOUNT = gql`
  ${BANK_ACCOUNT_FIELDS}
  query BankAccount($id: ID!) {
    bankAccount(id: $id) {
      ...BankAccountFields
    }
  }
`;

export const BANK_ACCOUNTS = gql`
  ${BANK_ACCOUNT_FIELDS}
  query BankAccounts {
    bankAccounts {
      ...BankAccountFields
    }
  }
`;

const BANK_ACCOUNT_ARGUMENTS = `
  $ownerType: String!
  $ownerId: ID!
  $accountName: String!
  $bankName: String!
  $routingNumber: String!
  $accountNumber: String!
  $type: String!
`;

const BANK_ACCOUNT_VARIABLES = `
  ownerType: $ownerType
  ownerId: $ownerId
  accountName: $accountName
  bankName: $bankName
  routingNumber: $routingNumber
  accountNumber: $accountNumber
  type: $type
`;

export const CREATE_BANK_ACCOUNT = gql`
  ${BANK_ACCOUNT_CORE_FIELDS}
  mutation CreateBankAccount (
    ${BANK_ACCOUNT_ARGUMENTS}
  ) {
    createBankAccount (
      ${BANK_ACCOUNT_VARIABLES}
    ) {
      bankAccount {
        ...BankAccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_BANK_ACCOUNT = gql`
  ${BANK_ACCOUNT_CORE_FIELDS}
  mutation UpdateBankAccount (
    $id: ID!
    ${BANK_ACCOUNT_ARGUMENTS}
  ) {
    updateBankAccount (
      id: $id
      ${BANK_ACCOUNT_VARIABLES}
    ) {
      bankAccount {
        ...BankAccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const HIDE_BANK_ACCOUNT = gql`
  ${BANK_ACCOUNT_CORE_FIELDS}
  mutation HideBankAccount ($id: ID!) {
    hideBankAccount (id: $id) {
      bankAccount {
        ...BankAccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UNHIDE_BANK_ACCOUNT = gql`
  ${BANK_ACCOUNT_CORE_FIELDS}
  mutation UnhideBankAccount ($id: ID!) {
    unhideBankAccount (id: $id) {
      bankAccount {
        ...BankAccountCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const BANK_ACCOUNTS_WITH_COUNT = gql`
  ${BANK_ACCOUNT_FIELDS}
  query (
    $ownerType: String
    $ownerId: ID
    ${WITH_COUNT_VARIABLES}
  ) {
    bankAccountsWithCount(
      ownerType: $ownerType
      ownerId: $ownerId
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ...BankAccountFields
      }
      count
    }
  }
`;
